import { IssueSeverity, VcsReportingChoices } from '~/types/types'

export const SEVERITY_RANK: Record<IssueSeverity, number> = {
  [IssueSeverity.Minor]: 1,
  [IssueSeverity.Major]: 2,
  [IssueSeverity.Critical]: 3
}

export const formatToggleValue = (enabled: boolean): string => (enabled ? 'On' : 'Off')

export const formatSeverityName = (severity: IssueSeverity): string => {
  return severity.charAt(0).toUpperCase() + severity.slice(1).toLowerCase()
}

const capitalizeLabel = (value: string): string => {
  if (!value) {
    return value
  }

  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const formatVcsReportingOptionLabel = (
  option: VcsReportingChoices,
  providerPrLabel: string,
  inlineCommentsOption: VcsReportingChoices = 'INLINE_COMMENTS' as VcsReportingChoices
): string => {
  switch (option) {
    case VcsReportingChoices.PrComment:
      return `${capitalizeLabel(providerPrLabel)} comments`
    case inlineCommentsOption:
      return 'Inline comments'
    default:
      return 'Integration setting'
  }
}
